import { ShieldOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const SecureAccessBadge = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 32,
        right: 32,
        p: 2,
        backgroundColor: 'primary.main',
        borderRadius: '16px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 160,
        zIndex: 1,
        gap: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          background: '#ffffff45',
          borderRadius: '10px',
        }}
      >
        <ShieldOutlined
          sx={{
            color: 'white',
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'start',
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'white' }}>
          Secure Access
        </Typography>
        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'white', fontWeight: 600 }}>
          Scaletech authorized accounts only
        </Typography>
      </Box>
    </Box>
  );
};

export default SecureAccessBadge;
